import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-formly-detailed-view',
  templateUrl: './formly-detailed-view.component.html',
  styleUrl: './formly-detailed-view.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class FormlyDetailedViewComponent {
  @Input() selectedNode: any;
  @Output() modelChange = new EventEmitter<any>();

  onModelChange(model: any) {
    this.modelChange.emit(model);
  }

  setFocusOnFormlyField(fieldName: string) {
   const element: any = document.getElementById(fieldName);
    if (element) {
      if (element instanceof HTMLInputElement ||
          element instanceof HTMLTextAreaElement)
      {
        element.focus();
      } else if (element && (element.nodeName == 'P-CALENDAR')) { // fix for datetime-picker component
         element.children[0].children[0].focus();
      } else if (element.nodeName === 'SELECT') { // fix for select element
         element.focus();
      }    
    }  
  }
}
